import { Navigate, RouteObject } from "react-router-dom";
import type { ProductCode } from "./types";

import EditorContextProvider from "./store/context";
import useTranslationPermissions from "./hooks/useTranslationPermissions";

import { Forbidden } from "@pages/errors/Forbidden";

/**
 * TODO:
 * Follow pattern in panopticon to programmatically build this list
 * based on products that are actually active for the FI.
 */
const PRODUCTS_MAP = {
  fi: "Global Messages",
  server: "Server Messages",
  olb: "Online Banking",
  app: "Mobile application",
  bao: "Business Account Opening",
  cao: "Consumer Account Opening",
  sao: "Staffer-led Account Opening",
  lending: "Lending",
} as Record<ProductCode, string>;

export const TRANSLATIONS_ROUTES: RouteObject[] = [
  {
    index: true,
    Component: () => <Navigate to="/fi" replace />,
  },
  ...Object.keys(PRODUCTS_MAP).map((product) => ({
    path: product,
    async lazy() {
      // @ts-expect-error no types yet
      const { TranslationsPage } = await import("./TranslationsContainer");
      return {
        Component() {
          const { addLanguage, editOtherMessage } = useTranslationPermissions();
          if (!addLanguage && !editOtherMessage && product === "fi") {
            return <Forbidden />;
          }
          return (
            <EditorContextProvider product={product as ProductCode}>
              <TranslationsPage productName={PRODUCTS_MAP[product as ProductCode]} />
            </EditorContextProvider>
          );
        },
      };
    },
  })),
];
